import { ActionReducerMapBuilder, Draft, PayloadAction } from '@reduxjs/toolkit'
import { DataList, saveErrorInState, dismissError as commonDismissError } from '../common'
import type { MediaState } from './types'
import type { fetchMedia, createMedia, modifyMedia, deleteMedia, fetchMediaEngineStats } from './mediaAPI'

export const selectIdReducer = (state: Draft<MediaState>, action: PayloadAction<number>) => {
  state.selectedIds = Array.from(new Set(state.selectedIds).add(action.payload))
}

export const unselectIdReducer = (state: Draft<MediaState>, action: PayloadAction<number>) => {
  const set = new Set(state.selectedIds)
  set.delete(action.payload)
  state.selectedIds = Array.from(set)
}

export const openModalReducer = (state: Draft<MediaState>, action: PayloadAction<string | null>) => {
  state.openedModal = action.payload
}

export const closeModalReducer = (state: Draft<MediaState>) => {
  state.openedModal = null
}

export const buildExtraReducers = (
  builder: ActionReducerMapBuilder<MediaState>,
  thunks: {
    fetchMedia: typeof fetchMedia
    createMedia: typeof createMedia
    modifyMedia: typeof modifyMedia
    deleteMedia: typeof deleteMedia
    fetchMediaEngineStats: typeof fetchMediaEngineStats
  }
) =>
  builder
    .addCase(thunks.fetchMedia.pending, DataList.fetchPending)
    .addCase(thunks.fetchMedia.fulfilled, DataList.fetchFulfilled)
    .addCase(thunks.fetchMedia.rejected, saveErrorInState(DataList.fetchRejected))
    .addCase(thunks.createMedia.pending, (state) => {
      state.fetching = true
    })
    .addCase(thunks.createMedia.fulfilled, (state) => {
      state.fetching = false
    })
    .addCase(
      thunks.createMedia.rejected,
      saveErrorInState((state) => {
        state.fetching = false
      })
    )
    .addCase(thunks.modifyMedia.pending, (state) => {
      state.fetching = true
    })
    .addCase(thunks.modifyMedia.fulfilled, (state) => {
      state.fetching = false
    })
    .addCase(
      thunks.modifyMedia.rejected,
      saveErrorInState((state) => {
        state.fetching = false
      })
    )
    .addCase(thunks.deleteMedia.pending, (state) => {
      state.fetching = true
    })
    .addCase(thunks.deleteMedia.fulfilled, (state) => {
      state.fetching = false
      state.selectedIds = []
    })
    .addCase(
      thunks.deleteMedia.rejected,
      saveErrorInState((state) => {
        state.fetching = false
        state.selectedIds = []
      })
    )
    .addCase(thunks.fetchMediaEngineStats.pending, (state) => {
      state.fetching = true
    })
    .addCase(thunks.fetchMediaEngineStats.fulfilled, (state, action) => {
      state.fetching = false
      state.engineStats = action.payload
    })
    .addCase(
      thunks.fetchMediaEngineStats.rejected,
      saveErrorInState((state) => {
        state.fetching = true
      })
    )

export { commonDismissError as dismissErrorReducer }
